import Cookies from "js-cookie";
import { useDispatch } from "react-redux";

import { policyUpdated } from "../store/actions/acceptPolicy";

const CookiePolicyModal = () => {
  const dispatch = useDispatch();

  const poliicyAgreeHandler = () => {
    if (typeof $ !== "undefined") {
      Cookies.set("accept-cookie", "true");
    dispatch(policyUpdated(true));
    $("#showCookiePolicy").modal("hide");

    }
    
  };

  return (
    <section className="restaurant-display">
      <div className="container">
        <div className="row">
          <div className="col-md-9 mx-auto">
            <div className="modal fade" id="showCookiePolicy" role="dialog">
              <div className="modal-dialog modal-dialog-centered">
                {/* <!-- Modal content--> */}
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                    >
                      &times;
                    </button>
                  </div>
                  <div className="modal-body pt-0">
                    <div className="restaurants closed-res">
                      <p className="policy-text">
                      <b>Dear Valued Customer</b>, 
Your privacy is very important to us, and we kindly ask for your attention before proceeding. 
In line with the nature of our business, we use cookies and web tracking technologies to:   
                       
                      </p>
                      <ul>
                        <li>
                         Personalize content and ads 
                        </li>
                        <li>
                         Provide social media features 
                        </li>
                        <li>
                         Analyze traffic on our platforms 
                        </li>
                      </ul>

                     
                      <p className="policy-text">
                      We may also share information about your use of our website with our trusted social media, advertising, and analytics partners. At various points where your personal data is requested, we will remind you of this. 
In accordance with the NDPA, by continuing to use this website, you consent to the processing of your personal data by <b>Sundry Foods Limited</b>, its agents, partners, and affiliated companies as outlined in our policies. 
You may update or modify your preferences at any time using the options below. We also work with an industry framework that communicates your preferences to our participating vendors. 
For more details, please review our  <a
                          href="/privacy-policy"
                          className="red-text"
                          
                        >
                          Privacy Policy.
                        </a>
                      </p>
                    </div>
                    <div class="text-right">
  <div class="d-inline-flex gap-2">
    <button onClick={poliicyAgreeHandler} class="btn mr-2">
      <span class="text">Agree</span>
    </button>
    <button onClick={poliicyAgreeHandler} class="btn-white ml-2">
      <span class="text">Reject</span>
    </button>
  </div>
</div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CookiePolicyModal;
